import { render } from "./ResultsListnew.vue?vue&type=template&id=2a1d1c1a&scoped=true"
import script from "./ResultsListnew.vue?vue&type=script&lang=js"
export * from "./ResultsListnew.vue?vue&type=script&lang=js"

import "./ResultsListnew.vue?vue&type=style&index=0&id=2a1d1c1a&lang=scss"
import "./ResultsListnew.vue?vue&type=style&index=1&id=2a1d1c1a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3706327227/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1d1c1a"]])

export default __exports__